import styled from 'styled-components'

export const Line = styled.div`
    height: 1px;
    background: #e1e4ea;
    margin: 16px 0;
`
